import { useState } from "react";
import { DeleteModal } from "../../../components";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useNavigate } from "react-router";
import { usePartnerChallenges } from "../../../store/usePartnerChallenges";

dayjs.extend(relativeTime);

export const CompletedChallengesTable = () => {
  /** Hooks */
  const navigate = useNavigate();
  const { allCompletedChallenges } = usePartnerChallenges();
  /** State */
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Full name
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Partner
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Status
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Vouched issued
            </th>
          </tr>
        </thead>
        <tbody>
          {allCompletedChallenges?.map((item) => {
            return (
              <tr
                onClick={() => {
                  // @ts-ignore
                  navigate(`/edit-user/${item.user?._id}`);
                }}
                key={item._id}
                className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
              >
                <td className="px-2 sm:px-6 py-1 sm:py-4 break-all sm:whitespace-nowrap">
                  {/* @ts-ignore */}
                  {item?.user?.first_name} {item?.user?.last_name}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  {/* @ts-ignore */}
                  {item?.challenge?.partnerId?.name}
                </td>
                <td
                  className={`hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4 ${
                    item?.progress?.completed
                      ? "text-green-500"
                      : "text-orange-500"
                  }`}
                >
                  {item?.progress?.completed ? "Completed" : "In progress"}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {/* @ts-ignore */}
                  {item?.progress?.voucherIssued?.code}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <DeleteModal isOpen={isOpen} closeModal={toggleModal} />
    </div>
  );
};
